
import './viewAllScrutinizers.css';
import React, { useState, useEffect } from "react";

import jwt from 'jwt-decode';
import { GET_APPLICATION_LIST, GET_ALL_STAKEHOLDERS, GET_USER_BY_ROLES } from '../../../common/URLs';
import back from '../../../images/backButton.png';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { ROLES } from '../../../common/constants';
import { loaderService } from "../../../common/custom-loader/loader-service";
import ScrutinyDetails from './scrutinyDetails';
import { Container, Row, Col, Stack, Table } from 'react-bootstrap';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { KeyboardArrowLeftRounded } from '@mui/icons-material'
import { Fab } from '@mui/material';
import { PROD } from '../../../common/constants';
import { Box, CardContent, Card, Typography, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Link as RouterLink } from 'react-router-dom';
import Link from "@mui/material/Link";
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { useTranslation } from 'react-i18next';
import apiClient from '../../../axios';

function ViewAllScrutinizers() {
  const { t } = useTranslation();
  const [userID, setUserId] = useState();
  const [role, setRole] = useState();
  const [scrutinizers, setScrutinizers] = useState();
  const [scrutinizerID, setScrutinizerID] = useState();
  const [showMapping, setShowMapping] = useState(false);
  useEffect(() => {
    setUserId(location.state.userid);
    setRole(location.state.role);

  }, []);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (userID) {
      getAllScrutinizers();
    }
  }, [userID]);

  const viewMappingDetails = (scrutinizerID) => {
    setScrutinizerID(scrutinizerID);
    setShowMapping(true);
  }
  const onCountView = (params) => {
    navigate('/registrationHome/dashboard/viewAllStakeholders', {
      state: { userId: params }
    });
  }

  function getAllScrutinizers() {
    loaderService.showLoader();
    apiClient
      .post(GET_USER_BY_ROLES,
        {
          "roleName": role
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setScrutinizers(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }
  const scrutinizersArray = scrutinizers?.users;

  const columns = [
    {
      field: 'id', headerName: 'S.No', width: 60,
      renderCell: (index) => index.api.getRowIndex(index.row.id) + 1
    },
    {
      field: 'name', headerName: t('preReg.name'), width: 200,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
          {params.row.firstname + " " + params.row.middlename + " " + params.row.lastname}
        </div>
      ),
      valueGetter: (params) => {

        if (params) {

          return params.row.firstname + " " + params.row.middlename + " " + params.row.lastname

        } else return '-'

      }
    },
    { field: 'emailAddress', headerName: 'Email ID', width: 200 },
    // { field: 'address', headerName: 'Address', width: 200 },
    { field: 'gender', headerName: 'Gender', width: 120 },
    role === ROLES.RegAssistant ? {
      field: 'preRegCount', headerName: 'Pre-Registration Count', width: 200,
      renderCell: (params) => {
        return (<Link to={params} onClick={() => { onCountView(params?.row?.id) }}>{params.value}</Link>)
      }
    }
      : { field: 'scrutinyCount', headerName: 'Scrutiny Count', width: 120, renderCell: (params) => { return (<Link to={params} onClick={() => { viewMappingDetails(params?.row?.id) }}>{params.value}</Link>) } },

  ];

  return (
    <>
      {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG47</p>}

      <Card>
        <CardContent>
          <div hidden={showMapping}>
            <div style={{ display: "inline-flex" }}>
              <Typography variant="h4" sx={{ mb: 2 }}>
                <Fab component={RouterLink} to='../dashboard' size="small" aria-label="back" title='Back'>
                  <KeyboardArrowLeftRounded />
                </Fab>
              </Typography>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <div className="hitDetailsText">{role == ROLES.RegistrationScruitnizer ? "Scrutinizer Details" : role == ROLES.LeadRegScrutinizer ? "Lead Scrutinizer Details" : "Assistant Details"}</div>
            </div>
            {scrutinizersArray &&
              <Box style={{ height: 500, width: '100%', marginTop: "2vh" }}>
                <DataGrid
                  sx={{
                    '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                    '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '12px' },
                    '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '18px' },
                  }}
                  getRowHeight={() => 'auto'}
                  rows={scrutinizersArray}
                  columns={columns}
                  pageSize={10}
                  getRowId={(row) => row?.id}
                  components={{ Toolbar: QuickSearchToolbar }}
                />
              </Box>}
          </div>
          <div hidden={!showMapping} >
            <Typography variant="h4" sx={{ mb: 2 }}>
              <Fab component={RouterLink} to='../dashboard/viewAllScrutinizers' size="small" aria-label="back" title='Back' onClick={() => showMapping ? setShowMapping(false) : setShowMapping(true)} >
                <KeyboardArrowLeftRounded />
              </Fab>
            </Typography> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <ScrutinyDetails userid={scrutinizerID} role={role} />
          </div>
        </CardContent>
      </Card>

    </>
    // <div>
    //   <Container fluid>
    //     <Row>
    //       {/* <Col xs={12} md={3}>
    //                   <div className="viewall-sidebar-container">
    //                       <ArrowBackIosNew className="arrow-icon" onClick={() => showMapping ? setShowMapping(false):(navigate(-1))} />
    //                   </div>
    //               </Col> */}
    //       <Col xs={12} md={12}>
    //         {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG47</p>}


    //         <div hidden={showMapping}>
    //           <div style={{ display: "inline-flex" }}>            <Typography variant="h4" sx={{ mb: 2 }}>
    //             <Fab component={RouterLink} to='../dashboard' size="small" aria-label="back" title='Back'>
    //               <KeyboardArrowLeftRounded />
    //             </Fab>
    //           </Typography> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    //             <div className="hitDetailsText">{role == ROLES.RegistrationScruitnizer ? "Scrutinizer Details" : "Lead Scrutinizer Details"}</div></div>
    //           {scrutinizersArray?.length > 0 ? <div className="table-wrap">
    //             <table className="table-view-class">
    //               <tr className='tr trStyle'>
    //                 <th className='th colorBlack'>S.No</th>
    //                 <th className='th colorBlack'>Name</th>
    //                 <th className='th colorBlack'>EmailId</th>
    //                 <th className='th colorBlack'>Address</th>
    //                 <th className='th colorBlack'>Gender</th>
    //                 <th className='th colorBlack'>Scrutiny Count</th>

    //               </tr>
    //               {scrutinizersArray && scrutinizersArray.map((item, index) => {
    //                 return (
    //                   <tr className='tr' key={index}>
    //                     <td className='td'>{index + 1}</td>
    //                     <td className='td'>{item?.firstname + ' ' + item?.middlename + ' ' + item?.lastname}</td>
    //                     <td className='td'>{item?.emailAddress}</td>
    //                     <td className='td'>{item?.address}</td>
    //                     <td className='td'>{item?.gender}</td>
    //                     <td className='td'><a onClick={() => viewMappingDetails(item?.id)} style={{ color: "blue", textDecoration: "underline" }}>{item?.scrutinyCount}</a></td>
    //                   </tr>
    //                 )
    //               })}
    //             </table>
    //           </div> : <div className="table-wrap">
    //             <table className="table-view-class"><p className='table-no-data'>No data to display</p></table></div>}
    //         </div>

    //       </Col>
    //     </Row>
    //   </Container>
    // </div>
  );
}
export default ViewAllScrutinizers;

